import styled from 'styled-components';
import Button from '@whitelabel/component-library/src/components/Button';

export const StyledMainButton = styled(Button)`
  width: calc(100% - 2rem);
  position: fixed;
  bottom: 2rem;
  z-index: 1002;
`;
